import { useEffect, useRef } from 'react';
import { AlertCircle } from 'lucide-react';

// Inline error summary for the plan screens. Spec §4: errors are shown inline at the top with
// focus moved to the summary — never a toast, and never toast.error (which this app reroutes
// to the global banner).
export function PlanErrorSummary({ message, title = 'Something went wrong' }) {
  const ref = useRef(null);

  useEffect(() => {
    if (message) ref.current?.focus();
  }, [message]);

  if (!message) return null;

  return (
    <div
      ref={ref}
      tabIndex={-1}
      role="alert"
      className="mpg-focus-ring mb-6 flex w-full gap-3 rounded-2xl border-2 border-[color:var(--plan-error-text)] bg-[var(--plan-error-bg)] p-4 text-left"
    >
      <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-[color:var(--plan-error-text)]" aria-hidden="true" />
      <div>
        <h2 className="text-base font-bold text-[color:var(--plan-error-text)]">{title}</h2>
        <p className="mt-1 text-base text-[color:var(--plan-heading-text)]">{message}</p>
      </div>
    </div>
  );
}
